import React from "react";
import styled from "styled-components";

const Card = styled.div`
  border: 1px solid rgba(253, 181, 21, 0.12);
  box-shadow: rgba(23, 92, 230, 0.12) 0px 4px 24px;
  width: 360px;
  min-height: 440px;
  background-color: ${({ theme }) => theme.card};
  cursor: pointer;
  border-radius: 14px;
  overflow: hidden;
  padding: 22px 18px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  transition: all 0.25s ease-in-out;

  &:hover {
    transform: translateY(-6px);
    box-shadow: 0 0 30px 4px rgba(0, 0, 0, 0.35);
  }

  @media only screen and (max-width: 768px) {
    width: 330px;
    min-height: 420px;
  }
`;

const Image = styled.img`
  width: 100%;
  height: 200px;
  object-fit: contain;
  background-color: ${({ theme }) => theme.white};
  border-radius: 12px;
  box-shadow: 0 0 16px 2px rgba(0, 0, 0, 0.18);
  flex-shrink: 0;
`;

const Tags = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 4px;
  min-height: 56px;
`;

const Tag = styled.span`
  font-size: 12px;
  font-weight: 500;
  color: ${({ theme }) => theme.primary};
  background-color: rgba(253, 181, 21, 0.1);
  padding: 4px 8px;
  border-radius: 10px;
  line-height: 1.3;
`;

const Details = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 0 2px;
  flex: 1;
  justify-content: space-between;
  gap: 10px;
`;

const Title = styled.div`
  font-size: 20px;
  font-weight: 600;
  color: ${({ theme }) => theme.text_secondary};
  line-height: 1.35;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  min-height: 82px;

  @media only screen and (max-width: 768px) {
    font-size: 18px;
    min-height: 74px;
  }
`;

const Date = styled.div`
  font-size: 12px;
  margin-left: 2px;
  font-weight: 400;
  color: ${({ theme }) => `${theme.text_secondary}CC`};
  margin-top: auto;

  @media only screen and (max-width: 768px) {
    font-size: 10px;
  }
`;

const ProfessionalCertificateCard = ({ certificate }) => {
  return (
    <Card
      onClick={() => window.open(certificate.link, "_blank", "noopener,noreferrer")}
      role="button"
      tabIndex={0}
    >
      <Image src={certificate.image} alt={certificate.title} />
      <Tags>
        {certificate.tags?.map((tag, index) => (
          <Tag key={index}>{tag}</Tag>
        ))}
      </Tags>
      <Details>
        <Title>{certificate.title}</Title>
        <Date>{certificate.date}</Date>
      </Details>
    </Card>
  );
};

export default ProfessionalCertificateCard;
